import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.drawer`;
export const INIT = `${SCOPE}/INIT`;
export const OPEN_NOC_DRAWER = `${SCOPE}/OPEN_NOC_DRAWER`;
export const CLOSE_NOC_DRAWER = `${SCOPE}/CLOSE_NOC_DRAWER`;

export const NAVIGATE_TO_TRENDS = `${SCOPE}/NAVIGATE_TO_TRENDS`;
export const NAVIGATE_TO_RT = `${SCOPE}/NAVIGATE_TO_RT`;

export const RESET_TRENDS_FILTER = `${SCOPE}/RESET_TRENDS_FILTER`;
export const RESET_FILTERS_FILTER = `${SCOPE}/RESET_FILTERS_FILTER`;

export const SET_INITIAL_FILTERS_TO_DRAWER = `${SCOPE}/SET_INITIAL_FILTERS_TO_DRAWER`;
export const SET_INITIAL_TRENDS_FILTER_TO_DRAWER = `${SCOPE}/SET_INITIAL_TRENDS_FILTER_TO_DRAWER`;

export const SET_NOC_URL = `${SCOPE}/SET_NOC_URL`;

export const TOGGLE_DIMENSION_IN_TRENDS_NOC_DRAWER = `${SCOPE}/TOGGLE_DIMENSION_IN_TRENDS_NOC_DRAWER`;
export const TOGGLE_DIMENSION_IN_FILTERS_NOC_DRAWER = `${SCOPE}/TOGGLE_DIMENSION_IN_FILTERS_NOC_DRAWER`;

export const ADD_METRIC_TO_FILTER_BAR = `${SCOPE}/DD_METRIC_TO_FILTER_BAR`;

export const SELECT_NOC_TRENDS_FILTER_BAR = `${SCOPE}/SELECT_NOC_TRENDS_FILTER_BAR`;
export const ADD_NEW_NOC_TRENDS_FILTER_BAR = `${SCOPE}/ADD_NEW_NOC_TRENDS_FILTER_BAR`;
export const DELETE_NOC_TRENDS_FILTER_BAR = `${SCOPE}/DELETE_NOC_TRENDS_FILTER_BAR`;

export const SELECT_NOC_FILTERS_FILTER_BAR = `${SCOPE}/SELECT_NOC_FILTERS_FILTER_BAR`;
export const ADD_NEW_NOC_FILTERS_FILTER_BAR = `${SCOPE}/ADD_NEW_NOC_FILTERS_FILTER_BAR`;
export const DELETE_NOC_FILTERS_FILTER_BAR = `${SCOPE}/DELETE_NOC_FILTERS_FILTER_BAR`;

export const DELETE_SAVED_NOC_FILTERS_FILTER_BAR = `${SCOPE}/DELETE_SAVED_NOC_FILTERS_FILTER_BAR`;

export const SELECT_MULTIPLE_DIMENSION_FROM_DIMESION_HEADER = `${SCOPE}/SELECT_MULTIPLE_DIMENSION_FROM_DIMESION_HEADER`;
export const UNSELECT_MULTIPLE_DIMENSION_FROM_DIMESION_HEADER = `${SCOPE}/UNSELECT_MULTIPLE_DIMENSION_FROM_DIMESION_HEADER`;
